import { useEffect } from 'react';

import { DeliveryDayOfWeekKorean } from '../../../api/subscription/dto/get-my-subscriptions.dto';
import { useChannelTalkStore } from '../../../store/channelTalkStore';
import { PaymentMethodKorean } from '../../../type';
import ChannelService from '../../../utils/channel';
import { HomeCookingTypeKorean } from '../../common/home-cooking-types';
import { CHANNEL_PLUGIN_KEY } from '../../common/next-migration';
import { DeliveryTypeKorean } from '../../delivery';
import useMyPointHistoryQuery from '../react-query/useMyPointHistoryQuery';
import useMeQuery from '../react-query/user/useMeQuery';
import { usePathnameMethod } from '../usePathnameMethod';

const useChannelTalk = () => {
  const { me } = useMeQuery();
  /** 적립금 잔액은 users/me가 아니라 /point/me가 SSoT다 */
  const { data: pointData, isLoading: isPointLoading } =
    useMyPointHistoryQuery();
  const { pathnameIncludes } = usePathnameMethod();
  const setIsChannelTalkBooted =
    useChannelTalkStore.use.setIsChannelTalkBooted();

  useEffect(() => {
    if (pathnameIncludes(['buynow', 'customize'])) {
      ChannelService.shutdown();
    } else {
      const gtmUser = {
        signUpType: me?.signUpType?.toLowerCase(),
        signUpYear: me?.signUpYear,
        signUpWeek: me?.signUpWeek,
        subscribeYear: me?.subscribeYear,
        subscribeWeek: me?.subscribeWeek,
        firstOrderYear: me?.firstOrderYear,
        firstOrderWeek: me?.firstOrderWeek,
        subscriptionId: me?.subscriptionId,
        countSubscription: me?.countSubscription,
        productId: me?.productId,
        productName: me?.productName,
        deliveryInterval: me?.deliveryInterval,
        deliveryType:
          me?.deliveryType != null
            ? DeliveryTypeKorean[me?.deliveryType]
            : me?.deliveryType,
        deliveryDay:
          me?.deliveryDay != null
            ? DeliveryDayOfWeekKorean[me?.deliveryDay]
            : me?.deliveryDay,
        payment:
          me?.payment != null ? PaymentMethodKorean[me?.payment] : me?.payment,
        allergies: me?.allergies,
        reviewCount: me?.reviewCount,
        orderCount: me?.orderCount,
        isPaused: me?.isPaused,
        point: isPointLoading ? undefined : pointData.points,
        recipeCount: me?.recipeCount,
        cookDiaryCount: me?.cookDiaryCount,
        countPurchase: me?.countPurchase,
        userdataType:
          me?.userdataType != null
            ? HomeCookingTypeKorean[me?.userdataType]
            : me?.userdataType,
        isSubscribing: me?.isSubscribing,
        hasSubscriptionHistory: me?.hasSubscriptionHistory,
        numberOfOrders: me?.numberOfOrders,
        hasRecipeCreatorProfile: me?.hasRecipeCreatorProfile,
        membership: me?.hasMembership,
      };

      ChannelService.boot(
        {
          pluginKey: CHANNEL_PLUGIN_KEY,
          customLauncherSelector: '.channel-talk-button',
          profile: {
            ...gtmUser,
            name: me?.name ?? '비회원',
            mobileNumber: me?.phone ?? '',
            email: me?.email,
          },
          hideChannelButtonOnBoot: true,
        },
        /**
         * @link https://developers.channel.io/reference/web-channelio-kr#boot
         */
        function onBoot(error: any, user: any) {
          if (error) {
            console.error(error);
          } else {
            setIsChannelTalkBooted(!!user);
          }
        },
      );
    }
  }, [
    me,
    pointData.points,
    isPointLoading,
    pathnameIncludes,
    setIsChannelTalkBooted,
  ]);
};

export default useChannelTalk;
